module.exports = __webpack_public_path__ + "static/media/YM80_1.8765da28.jpg";